module.exports = __webpack_public_path__ + "img/img_futa_ribbons.69bd8025.png";